import { Link } from "react-router-dom";
import { ArrowLeft, ArrowRight, Leaf } from "lucide-react";
import { FadeIn, Eyebrow } from "@/components/Reveal";
import Seo from "@/components/Seo";
import { PROTECT } from "@/data/rural";

const RuralProtect = () => (
  <div data-testid="rural-protect-page">
    <Seo
      title="Earn From Your Land. Care for What Makes It Special."
      description="Bushfire, flooding, koala habitat, waterways, biosecurity and neighbours — responsible land management for NSW rural hosts."
    />
    <section className="bg-sand-light/40">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-14 lg:py-16">
        <Link to="/rural" data-testid="protect-back" className="inline-flex items-center gap-2 text-xs font-mono uppercase tracking-[0.16em] text-charcoal/60 hover:text-teal transition-colors">
          <ArrowLeft className="w-4 h-4" /> Rural Land
        </Link>
        <FadeIn>
          <h1 className="mt-5 font-serif text-3xl sm:text-4xl lg:text-5xl text-teal tracking-tight">{PROTECT.title}</h1>
          <p className="mt-4 text-base md:text-lg text-charcoal/75 leading-relaxed">{PROTECT.lead}</p>
        </FadeIn>
      </div>
    </section>

    <section className="py-12 lg:py-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid sm:grid-cols-2 gap-5" data-testid="protect-topics">
          {PROTECT.topics.map((t, i) => (
            <FadeIn key={t.title} delay={i * 0.04}>
              <div className="h-full bg-white border border-cloud p-6">
                <div className="flex items-center gap-2.5">
                  <Leaf className="w-4 h-4 text-teal/60" />
                  <h2 className="font-serif text-xl text-teal">{t.title}</h2>
                </div>
                <ul className="mt-4 space-y-2.5">
                  {t.points.map((p, j) => (
                    <li key={j} className="flex gap-3 text-sm text-charcoal/80 leading-relaxed">
                      <span className="mt-2 w-1.5 h-1.5 rounded-full bg-sand shrink-0" />
                      {p}
                    </li>
                  ))}
                </ul>
              </div>
            </FadeIn>
          ))}
        </div>

        <FadeIn>
          <div className="mt-10 bg-sand-light/50 border border-cloud p-7 text-center">
            <p className="font-serif text-xl text-teal leading-relaxed max-w-2xl mx-auto">{PROTECT.closing}</p>
            <div className="mt-6 flex flex-wrap justify-center gap-3">
              <Link to="/rural/resources" data-testid="protect-cta-resources" className="inline-flex items-center gap-2 bg-teal text-ivory text-sm font-medium px-6 py-3 rounded-full hover:bg-teal-dark transition-colors">
                Safety &amp; Resource Hub <ArrowRight className="w-4 h-4" />
              </Link>
              <Link to="/rural/guest-pack" className="inline-flex items-center gap-2 border border-teal text-teal text-sm font-medium px-6 py-3 rounded-full hover:bg-teal hover:text-ivory transition-colors">
                Build these rules into my guest pack
              </Link>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>
  </div>
);

export default RuralProtect;
